import React from "react";
import "./utils/mapboxGlInit";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AuthenticationContextProvider from "./contexts/AuthenticationContext";
import ConfigContextProvider from "./contexts/ConfigContext";
import VerificationContextProvider from "./contexts/VerificationContext";
import NotificationsContextProvider from "./contexts/NotificationsContext";
// import OverviewContextProvider from "./contexts/OverviewContext";
import { Provider } from "react-redux";
import { store } from "./redux/store";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <BrowserRouter>
      <AuthenticationContextProvider>
        <VerificationContextProvider>
          <ConfigContextProvider>
            <NotificationsContextProvider>
              {/* <OverviewContextProvider> */}
              <Routes>
                <Route path="/*" element={<App />} />
              </Routes>
              {/* </OverviewContextProvider> */}
            </NotificationsContextProvider>
          </ConfigContextProvider>
        </VerificationContextProvider>
      </AuthenticationContextProvider>
    </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
